import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { leadQueryKeys } from "../lead";
import { deadlineDatesToUtc } from "./deadlineDatesToUtc";
import { taskQueryKeys } from "./taskQueryKeys";

export function useTaskEdit({ api, tz }: { api: ApiType; tz: string }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      taskId,
      patchedFields,
    }: {
      taskId: number;
      patchedFields: { [k: string]: any };
    }) => {
      let fields = { ...patchedFields };
      if (patchedFields["deadlineDate"] && patchedFields["deadlineTime"]) {
        fields = { ...fields, ...deadlineDatesToUtc(fields, tz) };
      }

      return (await api.taskApi.update(taskId, fields)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.list() });
    },
  });
}
